import parseCSSColor from "parse-css-color";

/**
 * Is there low contrast between white and the given color?
 * @param color {string} A CSS color
 * @return {boolean} true if there is low contrast between white and the given color
 */
function isGraphicLowContrastOnWhite(color) {
    return isGraphicLowContrast(color, 'white');
}

/**
 * Is there low contrast between the given colors?
 * @param color1 {string} A CSS color
 * @param color2 {string} A CSS color
 * @return {boolean} true if there is low contrast between the colors
 */
function isGraphicLowContrast(color1, color2) {
    const parsedColor1 = parseCSSColor(color1);
    const parsedColor2 = parseCSSColor(color2);
    return contrast(parsedColor1.values, parsedColor2.values) < 1.2;
}

//code "inspired" on https://github.com/LeaVerou/contrast-ratio/blob/d402291022c882c9ae5547b755afa9976460374c/color.js
//also this is important: https://stackoverflow.com/a/9733420
function luminance(r, g, b) {
    const a = [r, g, b].map(function (v) {
        v /= 255;
        return v <= 0.03928
            ? v / 12.92
            : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function contrast(rgb1, rgb2) {
    const lum1 = luminance(rgb1[0], rgb1[1], rgb1[2]);
    const lum2 = luminance(rgb2[0], rgb2[1], rgb2[2]);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    const opacity1 = rgb1.length === 4 ? rgb1[3] : 255;
    const opacity2 = rgb2.length === 4 ? rgb2[3] : 255;
    return ((brightest + 0.05) / (darkest + 0.05)) * (opacity1 / 255) * (opacity2 / 255);
}

export {isGraphicLowContrast, isGraphicLowContrastOnWhite}